<template>
  <div class="">
    <search-group title="" @search="findData" @clear="clearValue">
      <Row :gutter="25">
        <Col span="4">
        <Input class="block" v-model="searchData.roleName" placeholder="角色名称" @keyup.enter.native="findData" />
        </Col>
        <Col span="4">
        <Select placeholder="角色类型" v-model="searchData.roleType">
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in roleTypeList" :value="item.value" :key="'keyAA'+index">{{item.text}}</Option>
        </Select>
        </Col>
        <Col span="4">
        <Select :filterable="true"  v-model="searchData.orgId" placeholder="所属机构" clearable>
          <Option v-for="(item,index) in orgList" :value="item.value" :key="'keyA'+index">{{item.text}}</Option>
        </Select>
        </Col>
        <Col span="4">
        <Select placeholder="状态" v-model="searchData.status">
          <Option value="">请选择</Option>
          <Option v-for="(item,index) in roleStatusList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
        </Select>
        </Col>
        <Col span="4">
          <Select placeholder="所属应用" v-model="searchData.appType">
<!--            <Option value="">请选择</Option>-->
            <Option v-for="(item,index) in appTypeList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
          </Select>
        </Col>

      </Row>
    </search-group>
  </div>
</template>

<script>
// import SearchGroup from "components/SearchGroup/index";
import {rolecondition} from "../../../../api/character";

export default {
  // name: "SearchList",
  components: {
    // SearchGroup
  },
  data() {
    return {
      orgList:[],
      roleTypeList:[],
      roleStatusList:[],
      appTypeList:[{text:'一三环境',value:3}],
      searchData: {
        orgId:'' ,
        appType:3,
        roleName: "",
        status: '',
        roleType: '',
        orgIdSelf:[]
      }
    };
  },
  methods: {
    findData() {
      // this.searchData.orgId= '';
      this.$emit("findData", this.searchData);
    },
    clearValue() {
      this.searchData= {
          orgId:'' ,
          roleName: "",
          status: '',
          roleType: '',
          orgIdSelf:[],
          appType:null
      }
    }
  },
  created() {
    rolecondition().then(res=>{
      if(!res.data){
        return
      }
      this.orgList=res.data.org
      this.roleTypeList=res.data.roleType
      this.roleStatusList=res.data.status

    }).catch(error=>{

    })
    this.$emit('findData',this.searchData)

  }
};
</script>
<style scoped>
.flex {
  display: block;
}
.search-wrapper {
  padding: 24px 0 !important;
}

.shortcut a {
  display: inline-block;
  padding: 10px 20px;
  font-weight: bold;
  color: #444444;
}

.width200 {
  width: 200px;
}

.width300 {
  width: 300px;
}

.block {
  display: block;
}
</style>
